<template>
  <div class="content content--news">
    <OverlayLoader v-if="!$store.getters.newsLoaded && !$store.getters.newsCategoriesLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="
      [

        {
          name: section.value,
          path: `/${$route.params.companySlug}/news`
        }
      ]"/>

    <header class="content-header">
      <h1>
        {{section.value}}
        <template v-if="filters.category">( {{newsCategories.find(item => item.idSettingCompany === filters.category).value}} )</template>
      </h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList" v-if="newsCategories.length"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <div class="tabs-vertical">
          <ul class="tabs-inner">
            <li>
              <a :class="{'active': !filters.category}"  @click="filters.category = null; showList = false">
                All
                <i class="icon-arrow"></i>
              </a>
            </li>
            <li v-for="category in newsCategories" :key="category.idSettingCompany">
              <a :class="{'active': filters.category === category.idSettingCompany}"  @click="filters.category = category.idSettingCompany; showList = false">
                {{category.value}}
                <i class="icon-arrow"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <!-- News with tabs -->
    <div class="container main-content--tabbed" v-if="$store.getters.newsCategoriesLoaded && newsCategories.length">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tab-title">Categories</div>
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li>
                <a :class="{'active': !filters.category}"  @click="filters.category = null">
                  All
                  <i class="icon-arrow"></i>
                </a>
              </li>
              <li v-for="category in newsCategories" :key="category.idSettingCompany">
                <a :class="{'active': filters.category === category.idSettingCompany}"  @click="changeCategory(category.idSettingCompany)">
                  {{category.value}}
                  <i class="icon-arrow"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9">
          <NewsGrid box-class="col-lg-4" :boxes="news"></NewsGrid>
          <div class="buttons" v-if="isFullContentLoaded">
            <button @click="loadMore" class="button">Show 12 more results</button>
          </div>
        </div>
      </div>
    </div>

    <!-- News without tabs -->
    <div class="container main-content" v-else-if="$store.getters.newsCategoriesLoaded">
      <NewsGrid box-class="col-lg-3" :boxes="news"></NewsGrid>
      <div class="buttons" v-if="isFullContentLoaded">
        <button @click="loadMore" class="button">Show 12 more results</button>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import NewsGrid from "@/components/news/NewsGrid";
import OverlayLoader from "@/components/general/OverlayLoader";
import {debounce} from "@/helpers/debounce";
import settings from "@/settings";
import settingUser from "@/api/settingUser";
import moment from "moment/moment";
export default {
  name: "News",
  components: {OverlayLoader, NewsGrid, MyHeader},
  data () {
    return {
      showList: false,
      showCategories: false,
      filters: {
        category: '',
        per_page: 12,
        sort: 'date DESC'
      },
      page: 1
    }
  },
  computed: {
    newsCategories() {
      return this.$store.getters.newsCategories
    },
    section() {
      return this.$store.getters.sectionByCode(settings.MODULES.NEWS)
    },
    news() {
      return this.$store.getters.news
    },
    isFullContentLoaded() {
      return this.$store.getters.newsMetaInfo._lastPage && this.page < this.$store.getters.newsMetaInfo._lastPage
    },
  },
  mounted() {
    this.getNews()
    this.$store.dispatch('getNewsCategories')
    window._paq.push(['setDocumentTitle', this.section.value]);
    window._paq.push(['trackPageView']);
    this.updateNotificationDate();
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getNews()
      }
    },
    search: debounce(function (newVal) {
      this.filters.search = newVal
    }, 500)
  },
  methods: {
    changeCategory(category) {
      this.page = 1
      this.filters.category = category
    },
    updateNotificationDate() {
      settingUser.createSettingUser({
        idUser: this.$store.getters.user.idUser,
        idSettingCompany: this.section.idSettingCompany,
        valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      }, () => {
        this.$store.dispatch('updateNotification', this.section.idSettingCompany)
        this.$store.dispatch('getUserInfo')
      })
    },
    getNews(clean = true) {
      let params = {
        _embed: 1,
        _page: this.page,
        _per_page: this.filters.per_page,
        _sort: this.filters.sort
      }
      if(this.filters.category) {
        params.idCategory = this.filters.category
      }
      if(clean) {
        this.$store.dispatch('cleanNews')
      }
      this.$store.dispatch('getNews', params)
    },
    loadMore() {
      this.page += 1;
      this.getNews(false)

      // if (this.isFullContentLoaded) {
      // }
    },
  }
}
</script>
